import React from 'react';
import ValidationText from '../../../utils/validation/ValidationText.js';
import MultiSelectDropdown from '../../dropdown/MultiSelectDropdown.js';
import { printLandscapeFunction } from '../../print/printTemplate.js';

const SearchSection = (props) => {
    return (
        <>

            <div className="item-search flex gap-2.5 !mb-3">
                <div className="input-grp w-full" >
                    <label>Start Date</label>
                    <input
                        className={`inputFocus ${props.validState?.error?.startDate ? "errorInput" : ""}`}
                        type="date"
                        id="startDate"
                        name="startDate"
                        autoComplete="off"
                        value={props.filterDetails.startDate}
                        onChange={(event) =>
                            props.handleChange(event, "startDate")
                        }

                    />
                    {/* <ValidationText
                        error={props.validState.error.startDate}
                    /> */}
                </div>
                <div className="input-grp w-full">
                    <label>End Date</label>
                    <input
                        className={`inputFocus ${props.validState?.error?.endDate ? "errorInput" : ""}`}
                        type="date"
                        id="endDate"
                        name="endDate"
                        autoComplete="off"
                        value={props.filterDetails.endDate}
                        onChange={(event) =>
                            props.handleChange(event, "endDate")
                        }
                    />
                    {/* <ValidationText
                        error={props.validState.error.endDate}
                    /> */}
                </div>
                <div className="input-grp min-w-[40%]">
                    <label>Party Name</label>
                    <MultiSelectDropdown
                        drpIdentity="partyId"
                        options={props.partyDropdownList}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        onChange={(selected) =>
                            props.setFilterParameters(selected, "partyId")
                        }
                        allowSelectAll={false}
                        value={props.partyDropdownList.filter(
                            (party) =>
                                party.value === props.filterDetails.partyId
                        )}
                    />

                </div>
                {/* <div className="input-grp flex items-center pt-[18px] ml-2.5"  >
                    <input
                        className="inputFocus mr-[8px] !w-[18px] h-[18px]"
                        type="checkbox"
                        name="allParty"
                        id="allParty"
                        autocomplete="off"
                        value={props.filterDetails.allParty}
                        checked={props.filterDetails.allParty}
                        onChange={(event) =>
                            props.handleCheckbox(event, "allParty")
                        }
                    />
                    <label className="!mb-0 whitespace-nowrap">All Party</label>
                </div> */}

            </div>
            <div className="item-search flex gap-2.5 !mb-4">
                <div className="search-grp w-full">
                    <label>Invoice Type</label>
                    <select
                        name="invoiceType"
                        className="w-full"
                        value={props.filterDetails.invoiceType
                            && props.filterDetails.invoiceType !== 'Select'
                            && props.invoiceTypeList.find(
                                (party) => party.value === props.filterDetails.invoiceType
                            ).value}

                        onChange={(event) =>
                            props.handleDropDownChange(
                                event,
                                "invoiceType",
                                "filterDetails"
                            )
                        }>
                        {props.invoiceTypeList.map((x, key) => (
                            <option key={key} value={x.value}>
                                {x.invoiceType}
                            </option>
                        ))}
                    </select>
                </div>

                {/* {props.pageName === "gstPurchase" ? <div className="search-grp w-full">
                    <label>Material Type</label>
                    <select
                        name="materialType"
                        className="w-full"
                        value={props.filterDetails.materialType
                            && props.filterDetails.materialType !== 'Select'
                            && props.materialTypeList.find(
                                (party) => party.value === props.filterDetails.materialType
                            ).value}

                        onChange={(event) =>
                            props.handleDropDownChange(
                                event,
                                "materialType",
                                "filterDetails"
                            )
                        }>
                        {props.materialTypeList.map((x, key) => (
                            <option key={key} value={x.value}>
                                {x.materialType}
                            </option>
                        ))}
                    </select>
                </div> : null} */}

                {/* <div className="input-grp w-full" >
                    <label>GST Rate (%)</label>
                    <input
                        className="inputFocus"
                        type="number"
                        id="gstRate"
                        name="gstRate"
                        autoComplete="off"
                        value={props.filterDetails.gstRate}
                        onChange={(event) =>
                            props.handleChange(event, "gstRate")
                        }
                    />
                </div> */}
                <div className="search-grp w-full">
                    <label>Search</label>
                    <select
                        name="search"
                        className="w-full"
                        value={props.filterDetails.search
                            && props.filterDetails.search !== 'Select'
                            && props.searchList.find(
                                (party) => party.value === props.filterDetails.search
                            ).value}
                        onChange={(event) =>
                            props.handleDropDownChange(
                                event,
                                "search",
                                "filterDetails"
                            )
                        }>
                        {props.searchList.map((x, key) => (
                            <option key={key} value={x.value}>
                                {x.search}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="btn-grp">
                    <button
                        className="add-btn mt-auto"
                        onClick={() => props.getAllGstRegister()}>
                        Search
                    </button>
                    <button
                        className="cancel-btn mt-auto"
                        onClick={() => props.resetForm()}>
                        Cancel
                    </button>
                    {props.totalCount > 0 ?
                        <button
                            className="print-btn mt-auto"
                            onClick={() => printLandscapeFunction()}>
                            Print
                        </button> : null}
                </div>
            </div>
        </>
    );
};

export default SearchSection;